/** biome-ignore-all lint/performance/noAwaitInLoops: we disable no-await-in-loop here because we want to wait between retries */

function delay(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

async function retryAsync<T>(
  fn: () => Promise<T>,
  retries = 3,
  delayMs = 1000
): Promise<T> {
  let lastError;
  for (let attempt = 0; attempt < retries; attempt += 1) {
    try {
      return await fn();
    } catch (err) {
      lastError = err;
      if (attempt < retries - 1) {
        await delay(delayMs);
      }
    }
  }
  throw lastError;
}

export default retryAsync;
